export class ApiUtils {
    static getApiHttps() {
        return process.env.NODE_ENV === "production" ? 'https://api.v2.premierfire.app' : 'http://localhost:3000';
    }

    static getApiWs() {
        return process.env.NODE_ENV === "production" ? 'https://api.v2.premierfire.app/ws' : 'http://localhost:3000/ws';
    }
}